import React, { useState } from 'react';

import "./ModalImage.css";

const ModalImage = ({ images, handleCloseModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  if (images.length === 0) return null;

  return (
    <div className="Modal-Backdrop" onClick={handleCloseModal}>
      <div className="Modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-btn close-btn" onClick={handleCloseModal}>
          Back
        </button>

        <div className="modal-slider">
          <button className="modal-btn nav-btn" onClick={handlePrev}>
            ⟵
          </button>

          <img
            src={images[currentIndex].image}
            alt={images[currentIndex].name}
            className="modal-image"
          />

          <button className="modal-btn nav-btn" onClick={handleNext}>
            ⟶
          </button>
        </div>

        {/* <div className="image-caption">{images[currentIndex].name}</div> */}
      </div>
    </div>
  );
};

export default ModalImage;
